import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Container, customTheme } from './styles';

import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { AuthProvider } from '../contexts/auth';
import { DialogProvider } from '../contexts/dialog';
import ModalProvider from '../contexts/modal';
import SnackBarProvider from '../contexts/snackbar';
import Routes from '../routes';

function App() {
  const [loginPage, setLoginPage] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/login') {
      setLoginPage(true);
    } else {
      setLoginPage(false);
    }
  }, [location.pathname]);

  return (
    <AuthProvider>
      <MuiThemeProvider theme={customTheme}>
        <StyledThemeProvider theme={customTheme}>
          <ModalProvider>
            <Container isInLoginPage={loginPage}>
              <DialogProvider>
                <SnackBarProvider>
                  <Routes />
                </SnackBarProvider>
              </DialogProvider>
            </Container>
          </ModalProvider>
        </StyledThemeProvider>
      </MuiThemeProvider>
    </AuthProvider>
  );
}

export default App;
